module.exports = __webpack_public_path__ + "static/manager-2598bd705479f29b0f5367286dcead0b.png";